
import angry from "../assets/images/angry.png";
import bored from "../assets/images/bored.png";
import lazy from "../assets/images/lazy.png";
import worried from "../assets/images/worried.png";
import disappointed from "../assets/images/disappointed.png";
import accomplished from "../assets/images/accomplished.png";
import loved from "../assets/images/loved.png";
import joyful from "../assets/images/joyful.png";
import happy from "../assets/images/happy.png";
import excited from "../assets/images/excited.png";

export default [
  { id: 'excited', icon: excited, label: 'Excited' },
  { id: 'happy', icon: happy, label: 'Happy' },
  { id: 'joyful', icon: joyful, label: 'Joyful' },
  { id: 'loved', icon: loved, label: 'Loved' },
  { id: 'accomplished', icon: accomplished, label: 'Accomplished' },
  { id: 'disappointed', icon: disappointed, label: 'Disappointed' },
  { id: 'worried', icon: worried, label: 'Worried' },
  { id: 'lazy', icon: lazy, label: 'Lazy' },
  { id: 'bored', icon: bored, label: 'Bored' },
  { id: 'angry', icon: angry, label: 'Angry' },
]